// Generic two-way segmented control — the shared shape behind the
// Monthly/Annual toggle (Welcome/Billing) and the name/id search-mode
// toggle (Watchlists), previously three near-identical hand-rolled
// role="tablist" button pairs. Callers keep their own wrapper div
// (role="tablist", aria-label, className="seg") around it — that
// attribute placement is unchanged by this generalisation.
export function SegToggle<T extends string>({
  value,
  onChange,
  options,
}: {
  value: T;
  onChange: (v: T) => void;
  options: readonly [{ value: T; label: string }, { value: T; label: string }];
}) {
  return (
    <>
      {options.map((opt) => (
        <button
          key={opt.value}
          type="button"
          role="tab"
          aria-selected={value === opt.value}
          className={value === opt.value ? "btn" : "btn secondary"}
          onClick={() => onChange(opt.value)}
        >
          {opt.label}
        </button>
      ))}
    </>
  );
}

// Monthly/Annual segmented control shared by the Welcome and Billing plan
// pickers (C1) — previously duplicated JSX on both pages. Now a thin
// SegToggle wrapper so both call sites are unchanged.
export function IntervalToggle({
  value,
  onChange,
}: {
  value: "month" | "year";
  onChange: (v: "month" | "year") => void;
}) {
  return (
    <SegToggle
      value={value}
      onChange={onChange}
      options={[
        { value: "month", label: "Monthly" },
        { value: "year", label: "Annual" },
      ]}
    />
  );
}
